import React from "react"
import { connect } from "react-redux"
import "./UserAvatar.css"

function UserAvatar(props) {
  return (
    <div
      className={
        "user-avatar-box" +
        (props.type === "navbar" ? " navbar-avatar" : " teacher-info-avatar")
      }
    >
      <img
        src={props.icon || "../../assets/img/avatar.png"}
        className="user-avatar-img"
        alt="user's avatar"
      />
    </div>
  )
}

function mapStateToProps(state) {
  return {
    icon: state.user.user.img_url,
  }
}

export default connect(mapStateToProps)(UserAvatar)
